<template>
  <vs-card v-if="openSideConfig" style="max-width: 390px" class="config-card">
    <div class="flex flex-col justify-between h-full">
      <div>
        <div class="flex items-center justify-between p-6" style="border-bottom: solid 1px #d9d9d9">
          <p class="font-medium text-lg">구분 설정(관리자)</p>
          <button class="border-none outline-none" style="background: none" @click="$store.commit('ui/CLOSE_SIDECONFIG')">
            <feather-icon icon="XIcon" style="width: 24px; height: 24px; cursor: pointer" />
          </button>
        </div>
        <div class="p-5">
          <draggable v-model="categoryOptions" group="people" handle=".handle" @start="drag = true" @end="drag = false">
            <div v-for="(element, index) in categoryOptions" :key="element.id" class="flex items-center justify-between gap-5 p-2 mb-4">
              <feather-icon class="handle" icon="MenuIcon" style="width: 24px; height: 24px; cursor: pointer" />
              <ml-input v-model="element.name" class="flex-1" />
              <button class="border-none outline-none" style="background: none" @click="deleteCatogryOption(index)">
                <feather-icon icon="Trash2Icon" style="width: 24px; height: 24px; cursor: pointer" />
              </button>
            </div>
          </draggable>
          <vs-button @click="addSideConfig" color="secondary" type="border" class="w-auto">항목 추가</vs-button>
        </div>
      </div>
      <div class="flex items-center justify-end p-6" style="border-top: solid 1px #d9d9d9">
        <vs-button color="secondary" type="filled" class="w-auto" @click="saveSideConfig">완료</vs-button>
      </div>
    </div>
  </vs-card>
</template>

<script>
import draggable from "vuedraggable";

// 다른 board에서도 사용시 키 변경 코드 필요 1108전용로
const SIDE_CONFIG_KEY = "category_option_1108";

export default {
  components: { draggable },
  data() {
    return {
      categoryOptions: [],
    };
  },
  computed: {
    openSideConfig() {
      return this.$store.state.ui.openSideConfig;
    },
  },
  watch: {
    openSideConfig(value) {
      if (value) this.loadSideConfig();
    },
  },
  async created() {
    await this.loadSideConfig();
  },
  methods: {
    async loadSideConfig() {
      await this.$store.dispatch("ui/GET_SIDECONFIG", SIDE_CONFIG_KEY);

      const data = this.$store.state.ui.sideConfigMap[SIDE_CONFIG_KEY] || [];
      this.categoryOptions = data.map((x) => ({
        id: x.id,
        name: x.name,
      }));
    },

    addSideConfig() {
      const newId = Date.now();
      this.categoryOptions.push({
        id: newId,
        name: "",
      });
    },

    deleteCatogryOption(index) {
      this.categoryOptions.splice(index, 1);
    },

    async saveSideConfig() {
      // 빈 name 체크
      const invalid = this.categoryOptions.some((item) => !item.name || !item.name.trim());
      if (invalid) {
        this.customAlert("빈 항목이 있습니다.", "저장 실패");
        return;
      }

      // name 중복 제거
      const seen = new Set();

      this.categoryOptions = this.categoryOptions.filter((item) => {
        const key = item.name.trim();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      await this.$store.dispatch("ui/SAVE_SIDECONFIG", {
        key: SIDE_CONFIG_KEY,
        config: this.categoryOptions,
      });

      await this.$store.dispatch("ui/GET_SIDECONFIG", SIDE_CONFIG_KEY);
      this.$store.commit("ui/CLOSE_SIDECONFIG");
      this.customAlert("구분 설정이 저장되었습니다.", "저장 완료");
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
  },
};
</script>

<style lang="scss" scoped>
.config-card::v-deep .vs-card--content {
  height: 100%;
  padding: 0;
}
</style>
